import { render, staticRenderFns } from "./ReportsSalesRadarChart.vue?vue&type=template&id=360c5b1e&"
import script from "./ReportsSalesRadarChart.vue?vue&type=script&lang=js&"
export * from "./ReportsSalesRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports